var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.WidgetBaseComponent, {
    ref: "widgetRef",
    staticClass: "actions-resume-container",
    attrs: { loadedData: _setup.allDataLoaded && !_setup.showSpinner },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "header-bar" }, [
              _c("h2", [_vm._v(_vm._s(_setup.widgetData.title))]),
              _c("button", {
                class: [
                  _setup.icons.openWindow,
                  "open-window-button",
                  "lf-icon__md",
                ],
                on: { click: _setup.goToActionList },
              }),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "resumes-container" },
              _vm._l(_setup.widgetData.actions, function (counter, index) {
                return _c(_setup.LfWhiteCounterComponent, {
                  key: `counter-${index}`,
                  staticClass: "lf-counter",
                  attrs: { info: counter },
                })
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }